import { render, staticRenderFns } from "./DocumentTemplatePreviewDrawer.vue?vue&type=template&id=6f132375&scoped=true&lang=pug&"
import script from "./DocumentTemplatePreviewDrawer.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplatePreviewDrawer.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTemplatePreviewDrawer.vue?vue&type=style&index=0&id=6f132375&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f132375",
  null
  
)

/* custom blocks */
import block0 from "./DocumentTemplatePreviewDrawer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports